<template>
  <v-container fill-height justify-content-start class="app-section-width pa-0">
    <v-layout column>
      <v-layout
        flat
        class="activity-header"
        :class="{
          'light-green lighten-1': status === activityReservationStatus.ACCEPTED,
          'orange accent-2': status === activityReservationStatus.PENDING,
        }"
      >
        <v-layout row align-center class="px-4">
          <v-icon color="white" class="ms-3 me-3 display-1">{{
            status === activityReservationStatus.ACCEPTED
              ? "mdi-check-circle-outline"
              : "mdi-clock-outline"
          }}</v-icon>
          <v-toolbar-title class="white--text">
            {{ status === activityReservationStatus.ACCEPTED ? $t(`activity_reservation.complete.${reservationMethod.type}`) : $t('activity_reservation.pending') }}
          </v-toolbar-title>
        </v-layout>
      </v-layout>
      <v-flex class="app-scroll-section px-4 py-5">
        <span
          class="display-1"
          v-html="
            status === activityReservationStatus.ACCEPTED
              ? $t('activity_reservation.visit_reservations_prompt', {
                entityType: isRoomService ? $t('activity_reservation.order') : $t('activity_reservation.reservation'),
                dashboardName: getDashboardName({url: '/activity-reservations'})
              })
              : isRoomService ? $t('activity_reservation.confirmation_prompt_order') : $t('activity_reservation.confirmation_prompt_reservation')
          "
        ></span>
        <v-btn
          x-large
          @click="
            $router.push({
              name: routeNames.activity_reservations.name,
              query: { reservationId: activityReservations.lastReservation },
            })
          "
          outlined
          block
          color="primary"
          class="primary-gradient mt-10"
        >
          {{ $t("activity_reservation.actions.check", { entityType: isRoomService ? $t('activity_reservation.order') : $t('activity_reservation.reservation').toLowerCase() }) }}
        </v-btn>
      </v-flex>
      <v-layout justify-center class="ma-2" row wrap>
        <v-btn
          @click="$router.push({ name: routeNames.main.name })"
          outlined
          block
          color="secondary"
        >
          {{ $t("activity_reservation.actions.browse_other_activities") }}
        </v-btn>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import { activityReservationStatus } from '@/config'
import routeNames from '@/router/routes'

export default {
  beforeRouteEnter (to, from, next) {
    if (
      from.name !== routeNames.reservationSummary.name &&
      from.name !== routeNames.reservationCatalog.name &&
      from.name !== routeNames.catalogCategorySelection.name &&
      from.name !== routeNames.reservationError.name
    ) {
      next({ name: routeNames.main.name })
    } else {
      next()
    }
  },
  data () {
    return {
      routeNames,
      activityReservationStatus,
    }
  },
  created () {
    this.$store.dispatch('activities/getActivity', {
      id: this.$route.params.activityId,
    })
  },
  computed: {
    ...mapGetters({
      reservationMethod: 'activityReservations/reservationMethod',
      getDashboardName: 'service/getDashboardName',
    }),
    ...mapState(['activityReservations']),
    status () {
      return this.reservationMethod
        ? this.reservationMethod.autoAcceptReservation
          ? activityReservationStatus.ACCEPTED
          : activityReservationStatus.PENDING
        : null
    },
    isRoomService () {
      return this.reservationMethod && this.reservationMethod.type === 'ROOM_SERVICE'
    },
  },
  beforeRouteLeave (to, from, next) {
    localStorage.removeItem('reservationMethodType')
    next()
  },
}
</script>

<style scoped lang="scss">
.notranslate {
  transform: none !important;
}
.section-width {
  max-width: 800px !important;
}
.activity-header {
  max-height: 90px;
}
</style>
